import React from 'react';
import { LangConverter } from 'helpers/common';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from 'context/authContext';
import 'styled-components/macro';
import { useMediaPredicate } from 'react-media-hook';
import { StyledTableHeader, TotalResult, ResultPerPage, StyledSelect } from './TableHeader.styles';

function TableHeader({ exportBtn, total, resultPerPage, setPageSize, page, refresh, actionBtn, deleteAll }) {
  const { lang } = useContextHook(AuthContext, { lang: 1 });
  const MinWidth992 = useMediaPredicate('(min-width: 992px)');
  const resultPerPageOptions = [
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
  ];

  return (
    <StyledTableHeader>
      <TotalResult>
        {MinWidth992 && LangConverter('Showing', lang.value)} {page * resultPerPage - resultPerPage + 1} -{' '}
        {total <= resultPerPage ? total : page * resultPerPage}&nbsp;
        {LangConverter('of', lang.value)} {total} {LangConverter('results', lang.value)}
      </TotalResult>

      <ResultPerPage>
        {deleteAll ?? null}
        {refresh ?? null}
        {exportBtn ?? null}
        {actionBtn ?? null}

        <span css="margin-left: 15px;">{LangConverter('Result per page', lang.value)}:</span>
        <StyledSelect
          onChange={({
            target: {
              value: { value },
            },
          }) => setPageSize(value)}
          isSearchable={false}
          options={resultPerPageOptions}
          defaultValue={resultPerPageOptions[0]}
          sm
          noMargin
          css="padding:0;"
        />
      </ResultPerPage>
    </StyledTableHeader>
  );
}

export default TableHeader;
